import { useEffect, useRef, useState } from "react";
import { ManageShippingsViewModel } from "../../viewmodels/shipping/ManageShippingsViewModel";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import {
  formatDate,
  orderStatusOptions,
  withRouter,
} from "../../shared/utility";

import EmptyModal from "../../components/modals/EmptyModal";
import SlideOver from "../../components/slideOver/SlideOver";
import ActionLink from "../../components/controls/ActionLink";

import { Paginator } from "primereact/paginator";
import Pills from "../../components/controls/Pills";
import { classNames } from "primereact/utils";
import StatsComponents from "../../components/stats/StatsComponents";
import { isEmployeeUserType } from "../../shared/utility";

function ManageShippings(props) {
  const { addSnackbar, logout, user_type } = props;
  const isAdminUser = parseInt(user_type, 10) === 1;
  const {
    getShippings,
    loading,
    shippings,
    setEmptyModelOpen,
    setSlideOver,
    slideOver,
    emptyModal,
    setShowFilters,
    showFilters,
    resetFilters,
    getCustomersForDropdown,
    filterComponents,
    filters,
    askDeleteShipping,
    setFilters,
    setShowDates,
    analytics,
    showDates,
    fetchEstimates,
  } = ManageShippingsViewModel(logout, addSnackbar);

  const [isEmployee, setIsEmployee] = useState(false);

  var currentPage = 1;
  useEffect(() => {
    getCustomersForDropdown();
    getShippings(null, currentPage, filters);
    setIsEmployee(isEmployeeUserType());
  }, []);

  const [first, setFirst] = useState(1);
  const [rows, setRows] = useState(20);

  const searchRef = useRef();

  const handleSearch = () => {
    getShippings(searchRef.current.value, currentPage, filters);
  };

  const handlePagination = (event) => {
    currentPage = event.page + 1;
    setFirst(event.first);
    setRows(event.rows);
    getShippings(searchRef.current.value, currentPage, filters);
  };

  const convertStatus = (status) => {
    const statusOption = orderStatusOptions.filter((el) => el.value === status);

    return statusOption.length === 1
      ? { text: statusOption[0].label, type: statusOption[0].type }
      : { text: orderStatusOptions[0].label, type: orderStatusOptions[0].type };
  };

  const shippedDateBody = (rowData) => {
    return rowData.shipped_date
      ? formatDate(rowData.shipped_date)
      : "Not Shipped";
  };

  const createdDateBody = (rowData) => {
    return formatDate(rowData.created_at)
  };

  const statusBody = (rowData) => {
    return <Pills content={convertStatus(rowData.status)} />;
  };

  const massItemActionTemplate = (rowData) => {
    return (
      <div>
        <div className="flex">
          <ActionLink
            to={`/shippings/${rowData.id}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Edit
          </ActionLink>
          {isAdminUser ? (
            <button
              onClick={() => {
                askDeleteShipping(rowData);
              }}
              className="ml-2 rounded-md bg-red-600 px-3 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
            >
              Delete
            </button>
          ) : null}
        </div>
      </div>
    );
  };

  return (
    <div>
      <div className="mt-2">
        <div className="px-4 sm:px-6 lg:px-8">
          <StatsComponents
            analytics={analytics}
            setFilters={setFilters}
            filters={filters}
            setShowDates={setShowDates}
            showDates={showDates}
            handleSearch={handleSearch}
            filtersEnabled={true}
            showFilters={showFilters}
            filterComponents={filterComponents}
            resetFilters={resetFilters}
            setShowFilters={setShowFilters}
            hideDatesFilter={false}
          />
          <div className="sm:flex sm:items-center px-4 py-5 sm:px-4 card-custom">
            <div className="sm:flex-auto">
              <h1 className="text-base font-semibold leading-6 text-gray-900">
                Shippings
              </h1>
              <div
                className={classNames(
                  "mt-5 block sm:flex rounded-md space-y-4 sm:space-y-0",
                )}
              >
                <div className="relative flex items-stretch flex-grow focus-within:z-10">
                  <input
                    type="search"
                    name="searchProduct"
                    id="searchProduct"
                    className="block w-full rounded-lg rounded-l-md pl-2 sm:text-sm border border-gray-300 rounded-tr-none rounded-br-none"
                    placeholder="Search by po #, customer"
                    ref={searchRef}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handleSearch();
                    }}
                  />

                  <button
                    type="button"
                    className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1"
                    onClick={() => handleSearch()}
                  >
                    <MagnifyingGlassIcon
                      className="h-5 w-5 text-gray-400"
                      aria-hidden="true"
                    />
                  </button>

                  <button
                    onClick={fetchEstimates}
                    className="ml-2 rounded-md bg-main-purple px-3 py-1 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  >
                    Fetch Estimates
                  </button>
                </div>

                <div className="flex">
                  <div>
                    {/* <button
                    className="ml-2 rounded-md bg-main-purple px-2 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    onClick={() => navigate("/create-shipping")}
                  >
                    Create Shipping
                  </button> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-8 flow-root overflow-x-auto">
            <div className="inline-block min-w-full py-2 align-middle">
              {loading ? (
                <div>
                  <div className="border h-10 shadow rounded-md p-4 w-full mx-auto">
                    <div className="animate-pulse flex space-x-4">Loading</div>
                  </div>
                </div>
              ) : (
                <div className="overflow-hidden card-custom">
                  <DataTable
                    value={shippings.data}
                    dataKey="id"
                    tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm"
                    cellClassName="p-2 bg-white border-1-bottom-gray text-sm"
                  >
                    <Column
                      field="po_number"
                      header="PO #"
                      headerStyle={{ width: "15%" }}
                    />
                    <Column
                      field="customer"
                      header="Customer"
                      headerStyle={{ width: "30%" }}
                    />
                     <Column
                      field="invoice_number"
                      header="Invoice #"
                      headerStyle={{ width: "15%" }}
                    />
                    {isEmployee ? null : (
                      <Column
                        header="Date Created"
                        body={createdDateBody}
                        headerStyle={{ width: "20%" }}
                      />
                    )}
                    {isEmployee ? null : (
                      <Column
                        header="Date Shipped"
                        body={shippedDateBody}
                        headerStyle={{ width: "20%" }}
                      />
                    )}
                    <Column
                      header="Status"
                      body={statusBody}
                      headerStyle={{ width: "20%" }}
                    />
                    <Column
                      header=""
                      body={massItemActionTemplate}
                      headerStyle={{ width: "20%" }}
                    />
                  </DataTable>
                </div>
              )}
            </div>
            <div className="w-full">
              <Paginator
                first={first}
                rows={rows}
                totalRecords={shippings.total}
                onPageChange={handlePagination}
              />
            </div>
          </div>
        </div>
        <EmptyModal
          childComponent={emptyModal.childComponent}
          open={emptyModal.open}
          setOpen={setEmptyModelOpen}
        />
        <SlideOver
          childComponent={slideOver.childComponent}
          slideOver={slideOver}
          customClass="max-w-3xl"
          setSlideOver={setSlideOver}
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user_type: state.auth.user_type,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ManageShippings),
);
